import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { AgGridLoadingOverlayComponent } from '../../Common/AgGrid/agGridLoadingOverlay.component';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { TaxDotComDocsSvcLogService } from './taxDotComDocsSvcLog.service';
import { TaxDotComDocsSvcLogRepository } from './taxDotComDocsSvcLog.repository';
import { TaxDotComDocsSvcLogListComponent } from './TaxDotCom-DocsSvc-Log-List/taxDotComDocsSvcLogList.component';
import { TaxDotComDocsSvcLogListGridActionCellRendererComponent } from './TaxDotCom-DocsSvc-Log-List/agGridActionCellRenderer.component';
import { TaxDotComDocsSvcLogDetailsModalComponent } from './TaxDotCom-DocsSvc-Log-Details/taxDotComDocsSvcLogDetailsModal.component';
import { TaxDotComDocsSvcLogDetailsGridComponent } from './TaxDotCom-DocsSvc-Log-Details/taxDotComDocsSvcLogDetailsGrid.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule,
        BusyIndicatorModule.forRoot(),
        AgGridExtensionsModule,
        AgGridModule
    ],
    declarations: [
        TaxDotComDocsSvcLogListComponent,
        TaxDotComDocsSvcLogListGridActionCellRendererComponent,
        TaxDotComDocsSvcLogDetailsModalComponent,
        TaxDotComDocsSvcLogDetailsGridComponent
    ],
    providers: [
        TaxDotComDocsSvcLogService,
        TaxDotComDocsSvcLogRepository
    ],
    exports: []
})
export class TaxDotComDocsSvcLogModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('taxDotComDocsSvcLogList', TaxDotComDocsSvcLogListComponent);
        hybridAdapterUtility.downgradeNg2Component('taxDotComDocsSvcLogDetails', TaxDotComDocsSvcLogDetailsModalComponent);
        hybridAdapterUtility.downgradeNg2Component('taxDotComDocsSvcLogDetailsGrid', TaxDotComDocsSvcLogDetailsGridComponent);
    }
}
